import { FrenzyLine, Point } from "../Model";
import { findIntersectingLines } from "../Utils";

export function translateX(point: Point, xTranslation: number):Point {
  return [point[0] + xTranslation, point[1]];
}
export function translateY(point: Point, yTranslation: number):Point {
  return [point[0], point[1] + yTranslation];
}

export function translateXY(point: Point, xTranslation: number, yTranslation: number):Point {
  return [point[0] + xTranslation, point[1] + yTranslation];
}

export const isPointOnLine = (p: Point, lines: FrenzyLine[]) => {
  const hits = findIntersectingLines(p[0], p[1], lines);
  return hits.length > 0;
};

export function areSame(pointA: Point, pointB: Point):boolean {
  return pointA[0] === pointB[0] && pointA[1] == pointB[1];
}